// extracted by mini-css-extract-plugin
export default {"wrapper":"Toggle_wrapper__h7n5g","mode":"Toggle_mode__ijYNH","toggle":"Toggle_toggle__jlF-H","switch":"Toggle_switch__OWSrI","switch_active":"Toggle_switch_active__XHUFv"};